import $ from 'jquery'
import MediaQueries from "media-queries"
import "t-aria-accordion/src/js/aria-accordion.js"
import "t-aria-accordion/src/scss/aria-accordion.scss"

// send any slider a resize-command if the accordion was triggered
$(function() {
   $(window).on('ariaAccordion.slideDown ariaAccordion.slideUp', function(event,accordionGroup,index) {
       $(panel).trigger('resize.slider');
       $('.slider', panel).trigger('resize.slider');
   });
   let accordion = $('.accordion-group').ariaAccordion();
});